export const MAX_RETRY_NUMBER = 5;
export const MAX_TASK_ERROR_RETRY_NUMBER = 2;
export const REFETCH_DELAY = 2000;
